import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon.react';

const GenericAttachment = ({ url }) => (
  <a href={url} className="mt-10 btn btn-ff-base">
    <Icon icon="download" />
    {getFilename(url)}
  </a>
);

const getFilename = url => {
  const path = url.split('?')[0].split('/');
  return path[path.length - 1];
};

GenericAttachment.propTypes = {
  url: PropTypes.string.isRequired,
};

GenericAttachment.displayName = 'GenericAttachment';

export default GenericAttachment;
